import { render, staticRenderFns } from "./NicheShow_Mobile.vue?vue&type=template&id=540ad5f0&scoped=true&"
import script from "./NicheShow_Mobile.vue?vue&type=script&lang=js&"
export * from "./NicheShow_Mobile.vue?vue&type=script&lang=js&"
import style0 from "./NicheShow_Mobile.vue?vue&type=style&index=0&id=540ad5f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540ad5f0",
  null
  
)

export default component.exports